module.exports = __webpack_public_path__ + "media/assets/player/next-8bf1e0793048c5789678acf1981defb1.svg";